/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LookupKeyEnum,
    LookupKeyEnumFromJSON,
    LookupKeyEnumFromJSONTyped,
    LookupKeyEnumToJSON,
} from './LookupKeyEnum';
import {
    SourceSurveyEnum,
    SourceSurveyEnumFromJSON,
    SourceSurveyEnumFromJSONTyped,
    SourceSurveyEnumToJSON,
} from './SourceSurveyEnum';
import {
    StornoReasonEnum,
    StornoReasonEnumFromJSON,
    StornoReasonEnumFromJSONTyped,
    StornoReasonEnumToJSON,
} from './StornoReasonEnum';
import {
    SubscriptionEnum,
    SubscriptionEnumFromJSON,
    SubscriptionEnumFromJSONTyped,
    SubscriptionEnumToJSON,
} from './SubscriptionEnum';
import {
    SubscriptionSourceEnum,
    SubscriptionSourceEnumFromJSON,
    SubscriptionSourceEnumFromJSONTyped,
    SubscriptionSourceEnumToJSON,
} from './SubscriptionSourceEnum';
import {
    UserRoleEnum,
    UserRoleEnumFromJSON,
    UserRoleEnumFromJSONTyped,
    UserRoleEnumToJSON,
} from './UserRoleEnum';
import {
    UserSettingsEntity,
    UserSettingsEntityFromJSON,
    UserSettingsEntityFromJSONTyped,
    UserSettingsEntityToJSON,
} from './UserSettingsEntity';
import {
    UserTypeEnum,
    UserTypeEnumFromJSON,
    UserTypeEnumFromJSONTyped,
    UserTypeEnumToJSON,
} from './UserTypeEnum';

/**
 * 
 * @export
 * @interface UserEntity
 */
export interface UserEntity {
    /**
     * 
     * @type {UserRoleEnum}
     * @memberof UserEntity
     */
    role: UserRoleEnum | null;
    /**
     * 
     * @type {UserTypeEnum}
     * @memberof UserEntity
     */
    type: UserTypeEnum | null;
    /**
     * 
     * @type {SourceSurveyEnum}
     * @memberof UserEntity
     */
    sourceSurvey: SourceSurveyEnum | null;
    /**
     * 
     * @type {SubscriptionEnum}
     * @memberof UserEntity
     */
    subscription: SubscriptionEnum | null;
    /**
     * 
     * @type {SubscriptionEnum}
     * @memberof UserEntity
     */
    scheduledSubscription?: SubscriptionEnum | null;
    /**
     * 
     * @type {LookupKeyEnum}
     * @memberof UserEntity
     */
    lookupKey: LookupKeyEnum | null;
    /**
     * 
     * @type {SubscriptionSourceEnum}
     * @memberof UserEntity
     */
    subscriptionSource: SubscriptionSourceEnum | null;
    /**
     * 
     * @type {StornoReasonEnum}
     * @memberof UserEntity
     */
    stornoReason: StornoReasonEnum | null;
    /**
     * 
     * @type {LookupKeyEnum}
     * @memberof UserEntity
     */
    interestedInSubscription: LookupKeyEnum | null;
    /**
     * 
     * @type {UserSettingsEntity}
     * @memberof UserEntity
     */
    settings: UserSettingsEntity;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    isEmailVerified: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    isOnWaitingList: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    password: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    affiliateCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    nickname: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    newsletter: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    stripeCustomerId: string;
    /**
     * 
     * @type {Date}
     * @memberof UserEntity
     */
    subscriptionEndDate: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof UserEntity
     */
    subscriptionCanceledDate: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    hadTrialing: boolean;
    /**
     * 
     * @type {Date}
     * @memberof UserEntity
     */
    registrationDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserEntity
     */
    lastLoginDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserEntity
     */
    activationDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    stornoReasonDescription: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    hadStornoDiscount: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    agreedTerms: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    agreedMarketing: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    deleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    settingsId?: string;
}

export function UserEntityFromJSON(json: any): UserEntity {
    return UserEntityFromJSONTyped(json, false);
}

export function UserEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'role': UserRoleEnumFromJSON(json['role']),
        'type': UserTypeEnumFromJSON(json['type']),
        'sourceSurvey': SourceSurveyEnumFromJSON(json['sourceSurvey']),
        'subscription': SubscriptionEnumFromJSON(json['subscription']),
        'scheduledSubscription': !exists(json, 'scheduledSubscription') ? undefined : SubscriptionEnumFromJSON(json['scheduledSubscription']),
        'lookupKey': LookupKeyEnumFromJSON(json['lookupKey']),
        'subscriptionSource': SubscriptionSourceEnumFromJSON(json['subscriptionSource']),
        'stornoReason': StornoReasonEnumFromJSON(json['stornoReason']),
        'interestedInSubscription': LookupKeyEnumFromJSON(json['interestedInSubscription']),
        'settings': UserSettingsEntityFromJSON(json['settings']),
        'id': json['id'],
        'email': json['email'],
        'isEmailVerified': json['isEmailVerified'],
        'isOnWaitingList': json['isOnWaitingList'],
        'password': json['password'],
        'affiliateCode': json['affiliateCode'],
        'fullName': json['fullName'],
        'nickname': json['nickname'],
        'newsletter': json['newsletter'],
        'stripeCustomerId': json['stripeCustomerId'],
        'subscriptionEndDate': (json['subscriptionEndDate'] === null ? null : new Date(json['subscriptionEndDate'])),
        'subscriptionCanceledDate': (json['subscriptionCanceledDate'] === null ? null : new Date(json['subscriptionCanceledDate'])),
        'hadTrialing': json['hadTrialing'],
        'registrationDate': (new Date(json['registrationDate'])),
        'lastLoginDate': (new Date(json['lastLoginDate'])),
        'activationDate': (json['activationDate'] === null ? null : new Date(json['activationDate'])),
        'stornoReasonDescription': json['stornoReasonDescription'],
        'hadStornoDiscount': json['hadStornoDiscount'],
        'agreedTerms': json['agreedTerms'],
        'agreedMarketing': json['agreedMarketing'],
        'deleted': json['deleted'],
        'settingsId': !exists(json, 'settingsId') ? undefined : json['settingsId'],
    };
}

export function UserEntityToJSON(value?: UserEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'role': UserRoleEnumToJSON(value.role),
        'type': UserTypeEnumToJSON(value.type),
        'sourceSurvey': SourceSurveyEnumToJSON(value.sourceSurvey),
        'subscription': SubscriptionEnumToJSON(value.subscription),
        'scheduledSubscription': SubscriptionEnumToJSON(value.scheduledSubscription),
        'lookupKey': LookupKeyEnumToJSON(value.lookupKey),
        'subscriptionSource': SubscriptionSourceEnumToJSON(value.subscriptionSource),
        'stornoReason': StornoReasonEnumToJSON(value.stornoReason),
        'interestedInSubscription': LookupKeyEnumToJSON(value.interestedInSubscription),
        'settings': UserSettingsEntityToJSON(value.settings),
        'id': value.id,
        'email': value.email,
        'isEmailVerified': value.isEmailVerified,
        'isOnWaitingList': value.isOnWaitingList,
        'password': value.password,
        'affiliateCode': value.affiliateCode,
        'fullName': value.fullName,
        'nickname': value.nickname,
        'newsletter': value.newsletter,
        'stripeCustomerId': value.stripeCustomerId,
        'subscriptionEndDate': (value.subscriptionEndDate === null ? null : value.subscriptionEndDate.toISOString()),
        'subscriptionCanceledDate': (value.subscriptionCanceledDate === null ? null : value.subscriptionCanceledDate.toISOString()),
        'hadTrialing': value.hadTrialing,
        'registrationDate': (value.registrationDate.toISOString()),
        'lastLoginDate': (value.lastLoginDate.toISOString()),
        'activationDate': (value.activationDate === null ? null : value.activationDate.toISOString()),
        'stornoReasonDescription': value.stornoReasonDescription,
        'hadStornoDiscount': value.hadStornoDiscount,
        'agreedTerms': value.agreedTerms,
        'agreedMarketing': value.agreedMarketing,
        'deleted': value.deleted,
        'settingsId': value.settingsId,
    };
}

